import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { palette } from "../../themes/theme";
import { Close } from "@mui/icons-material";
import PrimaryButton from "../PrimaryButton";

const ConfirmationModal = ({
  open,
  handleClose,
  onSave,
  loading,
  headerTitle,
  description,
}) => {
  const handleSave = () => {
    onSave();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={"xs"}
      sx={{
        "& .MuiPaper-root": {
          background: palette.background.light,
          border: `1px solid ${palette.primary.main}`,
          borderRadius: "13px",
        },
      }}
    >
      <DialogTitle sx={{ color: palette.text.dark }}>{headerTitle}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <Close />
      </IconButton>
      <DialogContent dividers>
        <Typography color="textSecondary">{description}</Typography>

        <Box
          sx={{
            width: "100%",
            pt: "20px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{
              fontWeight: 500,
              fontSize: 16,
              borderRadius: "7px",
              boxShadow: "1px 3px 12px black",
              color: palette.text.white
            }}
            loading={loading}
            loadingPosition="end"
            onClick={handleSave}
          >
            Confirm
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
